const menuMobile = () => {
  let hamburger = document.querySelector('.hamburger');
  let menuSP = document.querySelector('.nav__sp');

  if(hamburger != undefined) {
    hamburger.addEventListener('click', () => {
      if(hamburger.classList.contains('is-active')) {
        hamburger.classList.remove('is-active');
        menuSP.classList.remove('show');
      }
      else {
        hamburger.classList.add('is-active');
        menuSP.classList.add('show')
      }
    })
  }
}

export default menuMobile